import { useContext, useEffect, useRef, useState } from 'react'
import { getSmartLockDevices } from '@/apis/aipass'
import { LoaderContextCreator } from '@/contexts/loader'
import { useErrorHandler } from '@/hooks/use-error-handler'
import { AccountInfo, Device, LockType } from '@/models/lock-setting'

export const useSmartLockDevices = (lockType: LockType, accountInfo: AccountInfo | undefined) => {
  const { errorHandler } = useErrorHandler()
  const { setIsLoading } = useContext(LoaderContextCreator())
  const [deviceList, setDeviceList] = useState<Device[]>()
  // 取得中に種別・連携状態が変わった場合に、古いリクエストの結果を捨てるための識別子
  const latestRequestId = useRef<number>(0)

  const fetchDevice = async (requestId: number) => {
    if (!accountInfo?.isConnected) {
      return
    }
    try {
      setIsLoading(true)
      const devices = await getSmartLockDevices({ lockType })
      if (requestId === latestRequestId.current) {
        setDeviceList(devices)
      }
    } catch (error) {
      errorHandler(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // 別種別のデバイスを割り当てられないよう、取得し直すまで候補を空にする
    latestRequestId.current += 1
    setDeviceList(undefined)
    fetchDevice(latestRequestId.current)
  }, [lockType, accountInfo])

  return { deviceList }
}
